import { ConnectProto } from "@racoon/api";
import { FC } from "react";
import { getStatusIcon } from "../model/review-status";
import { usePhotoReportModal } from "../model/use-photo-report-modal";
import { Namespace, useT } from "@racoon/i18n";

interface Props {
  job: ConnectProto.Job;
  /** Neighbouring jobs the report steps through with ↑/↓, read on open. */
  getJobs?: () => ConnectProto.Job[];
  /** Styles the trigger, itself the button — don't wrap it in another one. */
  triggerClassName?: string;
}

/** Opens a job's photo report from outside any table; one design for every job type. */
export const useOpenPhotoReport = () => {
  const openReport = usePhotoReportModal();
  return (job: ConnectProto.Job, jobs: ConnectProto.Job[] = [job]) => openReport(jobs, job);
};

export const PhotoReportModal: FC<Props> = ({ job, getJobs, triggerClassName }) => {
  const t = useT();
  const open = useOpenPhotoReport();
  const StatusIcon = getStatusIcon(job);

  return (
    <button
      type="button"
      data-testid="photo-report-open"
      aria-label={t(Namespace.PhotoReport, "seePhotoReport")}
      className={triggerClassName}
      onClick={(e) => {
        e.stopPropagation();
        open(job, getJobs?.());
      }}
    >
      <StatusIcon width={24} height={24} />
    </button>
  );
};
